import { render } from "./Navbar.vue?vue&type=template&id=279d481a&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=279d481a&scoped=true&lang=postcss"
script.render = render
script.__scopeId = "data-v-279d481a"

export default script